export const CHALLENGE_SMS_MFA_ISSUED = '@auth/CHALLENGE_SMS_MFA_ISSUED';
export const CHALLENGE_SMS_MFA_SUBMITTED = '@auth/CHALLENGE_SMS_MFA_SUBMITTED';
export const CHALLENGE_SMS_MFA_ACCEPTED = '@auth/CHALLENGE_SMS_MFA_ACCEPTED';
export const CHALLENGE_SMS_MFA_REJECTED = '@auth/CHALLENGE_SMS_MFA_REJECTED';

export const issueChallengeSmsMfa = () => ({
    type: CHALLENGE_SMS_MFA_ISSUED,
    payload: {},
});

export const submitChallengeSmsMfa = ({ code }) => ({
    type: CHALLENGE_SMS_MFA_SUBMITTED,
    payload: { code },
});

export const acceptChallengeSmsMfa = ({ user }) => ({
    type: CHALLENGE_SMS_MFA_ACCEPTED,
    payload: { user },
});

export const rejectChallengeSmsMfa = ({ code }) => ({
    type: CHALLENGE_SMS_MFA_REJECTED,
    payload: { code },
});
